import React, { useEffect, useState } from "react";
import { Row, Col, Button } from "react-bootstrap";
import DataTable from "../../../Pages/InputField/DataTable"; // Import the reusable DataTable component
import baseURL from "../../../../Url/NodeBaseURL";
import * as XLSX from "xlsx";
import { FaFileExcel } from "react-icons/fa";

const RepairsTable = () => {
  const [data, setData] = useState([]); // State to store table data
  const [loading, setLoading] = useState(true); // Loading state
  const [filteredRows, setFilteredRows] = useState([]);

  // Fetch data from the API
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${baseURL}/get/repairs`);
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const result = await response.json();

        // If the result is not an array, wrap it in an array
        setData(Array.isArray(result) ? result : [result]);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false); // Stop loading spinner
      }
    };

    fetchData();
  }, []);

  // Excel download function
const downloadExcel = () => {
  const exportData = filteredRows.length > 0 ? filteredRows : data;

  const excelData = exportData.map((item, index) => ({
    'Sr. No.': index + 1,
    'Date': new Date(item.date).toLocaleDateString('en-GB'),
    'Customer': item.account_name || '',
    'Mobile': item.mobile || '',
    'Invoice No': item.invoice_number || '',
    'Repair No': item.repair_no || '',
    'Entry Type': item.entry_type || '',
    'Category': item.category || '',
    'Gross Wt': item.gross_weight || '',
    'Amount': item.estimated_amt || '0.00',
    'Status': item.status || '',
  }));

  const worksheet = XLSX.utils.json_to_sheet(excelData);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Repairs Report');

  XLSX.writeFile(
    workbook,
    `Repairs_Report_${new Date().toISOString().split('T')[0]}.xlsx`
  );
};

  // Define columns for the table
  const columns = React.useMemo(
    () => [
      {
        Header: "S No",
        Cell: ({ row }) => row.index + 1, // Generate a sequential number based on the row index
      },
      {
        Header: "Date",
        accessor: "date",
        Cell: ({ value }) => {
          const date = new Date(value);
          return date.toLocaleDateString("en-GB"); // 'en-GB' formats as dd/mm/yyyy
        },
      },

      {
        Header: "Customer",
        accessor: "account_name",
      },
      {
        Header: "Mobile",
        accessor: "mobile",
      },
      {
        Header: "Invoice No",
        accessor: "invoice_number",
      },
      {
        Header: "Repair No",
        accessor: "repair_no",
      },
      {
        Header: "Entry Type",
        accessor: "entry_type",
      },
      {
        Header: "Category",
        accessor: "category",
      },
      // {
      //   Header: 'Item Name',
      //   accessor: 'sub_category',
      // },
      // {
      //   Header: 'Metal Type',
      //   accessor: 'metal_type',
      // },
      // {
      //   Header: 'Purity',
      //   accessor: 'purity',
      // },
      {
        Header: "Gross Wt",
        accessor: "gross_weight",
      },
      // {
      //   Header: 'Extra Wt',
      //   accessor: 'extra_weight',
      // },
      // {
      //   Header: 'Est Dust',
      //   accessor: 'estimated_dust',
      // },
      {
        Header: "Amount",
        accessor: "estimated_amt",
      },
      // {
      //   Header: 'MC',
      //   accessor: 'making_charge',
      // },

      // {
      //   Header: 'Total',
      //   accessor: row => row.total_amt ? row.total_amt : '0.00',
      // },

      {
        Header: "Status",
        accessor: "status",
      },
    ],
    [],
  );

  return (
    <div className="main-container">
      <div className="sales-table-container">
        <Row className="mb-3">
          <Col className="d-flex justify-content-between align-items-center">
            <h3>Repairs Report</h3>
            <Button
              variant="success"
              onClick={downloadExcel}
              disabled={loading || data.length === 0}
              className="d-flex align-items-center gap-2"
            >
              <FaFileExcel />
              Download Excel
            </Button>
          </Col>
        </Row>
        {loading ? (
          <p>Loading...</p> // Show loading message while fetching data
        ) : (
          <DataTable
            columns={columns}
            data={data}
            onFilterChange={setFilteredRows}
          />
        )}
      </div>
    </div>
  );
};

export default RepairsTable;
